export class GLAccountModel {
	glAccountId: number | null;
	glAccount: string;
	category: string;
	description: string;

	constructor() {
		this.glAccountId = null;
		this.glAccount = "";
		this.category = "";
		this.description = "";
	}
}
